import PropTypes from "prop-types";

const propTypes = {
  requestPermissions: PropTypes.func.isRequired
};

export default propTypes;
